import { styled } from '@mui/material'

export const FormFilterElement = styled('div')({
  justifyContent: 'center',
  padding: '0.5rem 1rem'
})

export const FormFilterPairedElements = styled('div')({
  display: 'flex',
  padding: '0.5rem 1rem',
  justifyContent: 'space-between',
  flexDirection: 'row',
  gap: '0.5rem'
})
